import type { TFunction } from 'i18next';

/**
 * 有 messageCode 且在 errorCodes 中有翻译则用 i18n；否则使用接口/异常返回的 message。
 * 均无则不返回兜底文案（空字符串），由调用方决定是否提示。
 */
export function getPlatformPermissionErrorMessage(
  t: TFunction,
  messageCode?: string | null,
  message?: string | null
): string {
  if (messageCode) {
    const key = `central.platformPermission.errorCodes.${messageCode}`;
    const translated = t(key) as string;
    if (translated && translated !== key) {
      return translated;
    }
  }
  return (message && message.trim()) || '';
}
